import { Component, Injector, OnInit, inject } from "@angular/core";
import { LocalRepository } from "@shared/helper/local-repository";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { SharedModule } from "@shared/module/shared.module";

@Component({
    selector: "app-confirm-alert",
    imports: [SharedModule],
    templateUrl: "./confirm-alert.component.html",
    styleUrls: ["./confirm-alert.component.scss"]
})
export class ConfirmAlertComponent implements OnInit {
  private _localRepository = inject(LocalRepository);

  private dialogData: AlertConfigModel;
  private bottomSheetData: AlertConfigModel;
  private dialogRef: MatDialogRef<ConfirmAlertComponent>;
  private bottomSheetRef: MatBottomSheetRef<ConfirmAlertComponent>;

  alertConfig!: AlertConfigModel;

  buttons: IAlertButton[] = [
    {
      text: "",
      classes: ["btn-green-mute"],
      type: EConfirmButton.CONFIRM,
      color: "primary",
    },
    {
      text: "",
      classes: ["btn-red", "hover:bg-red-50"],
      type: EConfirmButton.CANCLE,
      color: "warn",
    },
  ];

  constructor() {
    const injector = inject(Injector);

    this.dialogRef = injector.get(MatDialogRef, null)!;
    this.dialogData = injector.get(MAT_DIALOG_DATA, null);
    this.bottomSheetRef = injector.get(MatBottomSheetRef, null)!;
    this.bottomSheetData = injector.get(MAT_BOTTOM_SHEET_DATA, null);
  }

  ngOnInit(): void {
    if (this._localRepository.IsInMobile) {
      this.alertConfig = this.bottomSheetData;
      this.buttons[0].text = this.alertConfig.confirmButtonText || "بله";
      this.buttons[1].text = this.alertConfig.cancelButtonText || "خیر";
    } else {
      this.alertConfig = this.dialogData;
      this.buttons[0].text = this.alertConfig.confirmButtonText || "بله";
      this.buttons[1].text = this.alertConfig.cancelButtonText || "خیر";
    }
  }

  close(type: EConfirmButton) {
    if (this._localRepository.IsInMobile) {
      this.bottomSheetRef.dismiss(type);
    } else {
      this.dialogRef.close(type);
    }
  }
}

export class AlertConfigModel {
  title!: string;
  subTitle?: string;
  cancelButtonText!: string;
  confirmButtonText!: string;
}

export interface IAlertButton {
  text: string;
  classes: string[];
  type: EConfirmButton;
  color: string;
}

export enum EConfirmButton {
  CONFIRM = "confirm",
  CANCLE = "cancle",
}
